var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.20833V22.125C5 22.5287 5.24274 22.8928 5.61539 23.0481L17.5 28M5 8.20833L16.7308 3.32051C17.2231 3.11538 17.7769 3.11538 18.2692 3.32051L23.75 5.60417M5 8.20833L11.25 10.8125M17.5 13.4167V28M17.5 13.4167L30 8.20833M17.5 13.4167L11.25 10.8125M17.5 28L29.3846 23.0481C29.7573 22.8928 30 22.5287 30 22.125V8.20833M30 8.20833L23.75 5.60417M11.25 10.8125L23.75 5.60417",
    stroke: "#C5CCD3",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxIcon);
export default __webpack_public_path__ + "static/media/max_icon.aeb8cc94bbab71322da7437002429540.svg";
export { ForwardRef as ReactComponent };